import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=6efc596a&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=6efc596a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc596a",
  null
  
)

export default component.exports